/** @jsxImportSource theme-ui @jsxRuntime classic */
import React from 'react';

import { PageTransitionContext } from './context';

import type { FC, ReactNode } from 'react';

export const PageTransitionProvider: FC<{
  id: string;
  children: ReactNode;
}> = ({ children, id }) => (
  <PageTransitionContext.Provider value={id}>
    {children}
  </PageTransitionContext.Provider>
);
